<template>
    <v-card class="custom-card mx-auto" >
        <v-img :class="displayCursor"  @click="click" class="white--text" :max-height="height + 'px'" :src="src || defaultImage">
            <v-card-title class="align-end fill-height">{{title || ""}}</v-card-title>
        </v-img>                      
        <v-card-text v-if="text && text.length > 0" >
            {{ text || '' }}
        </v-card-text>        
        <div class="flex-grow-1"></div>          
        <v-card-actions>
            <slot name="actions"></slot>
            <v-chip v-if="!actived" :color="'red'" dark>Desativado</v-chip>
            <!-- <v-btn  @click="editItem(l)" text color="nav">{{ $vuetify.lang.t('$vuetify.dataTable.edit') }}</v-btn>
            <v-btn @click="deleteItem(l)" text color="nav">{{ $vuetify.lang.t('$vuetify.dataTable.delete') }}</v-btn> -->
        </v-card-actions>
    </v-card>
</template>

<script>
export default {    
    name: "CustomCard",
    props: {
        maxWidth: {
            type: String
        },
        maxHeight: {
            type: String
        },
        actived: Boolean,
        src: {
            type: String,
        },
        title: {
            type: String
        },
        text: {
            type: String
        },
        clickImage: {
            type: Function
        },
        cursor: String
    },
    computed: {
        width() {
            return this.maxWidth || "400";
        },
        height() {
            return this.maxHeight || "200";
        },
        displayCursor() {
            return this.cursor || 'pointer'
        }
    },

    methods: {
        click() {
            if (this.clickImage)
                this.clickImage();
        }
    }
}
</script>

<style lang="scss">

    .custom-card .v-card__title.align-end.fill-height {
        font-size: 16px;
    }

    .custom-card .v-responsive__content {        
        background-color: #000;
        opacity: 0.5
    }

    // .custom-card .v-responsive.v-image {
    //     cursor: pointer;
    // }

    .pointer {cursor: pointer;}

    .scroll  {cursor: all-scroll;}

    .custom-card .v-image__image.v-image__image--cover {
        transition: transform .8s;
    }

    .custom-card .v-image__image.v-image__image--cover:hover {
        transform: scale(1.5);
    }

</style>